import { z } from 'zod'

import { organisationShortSchema } from './organisationShort'

export const storeSchema = z.object({
  id: z.string(),
  ownerShortModel: organisationShortSchema.nullable(),
  code: z.number(),
  description: z.string(),
  address: z.string(),
  contactPersons: z.string(),
  isRemote: z.boolean(),
  isActive: z.boolean(),
  storeStatusModel: z.object({ id: z.string() }).nullable(),
  comment: z.string(),
})

export const storeShortSchema = z.object({
  id: z.string(),
  code: z.number(),
  description: z.string(),
  owner: z.string(),
  etaCutoffTime: z.any(),
  isRemote: z.boolean(),
  isActive: z.boolean(),
})

export const storeShortWithSupplierSchema = storeShortSchema.extend({
  supplierId: z.string(),
})
